export default __webpack_public_path__ + "static/media/enconstruccion.307e68a4.svg";